<template>
  <div class="header">
    <div class="top">
        <div class="info">
          <template v-if="!$store.state.loginStatus">
            <router-link tag="span" to="login">登录</router-link>
            <router-link tag="span" to="register">注册</router-link>
          </template>
          <template v-else>
            <span>{{$store.state.user.name}}</span>
            <router-link tag="span" to="order">我的订单</router-link>
            <router-link tag="span" to="address">我的地址</router-link>
            <span @click="clickOut">退出登录</span>
          </template>
        </div>
      </div>
    <div class="w1000">
      <div class="logo">
        <router-link tag="a" to="index">
          {{$webData.webNm}}
        </router-link>
      </div>
      <router-link tag="div" class="cart" to="cart">
        <span>
          <i>{{$store.state.cartNum}}</i>
        </span>
        我的购物车
      </router-link>
    </div>
    <div class="headInfo">
        <div class="nav">
            <ul>
                <li :class="{'active':$store.state.navNum===0}"><router-link tag="a" to="index">商城首页</router-link></li>
                <li :class="{'active':$store.state.navNum===51}"><a @click="goPage(51,'历史书籍')">历史书籍</a></li>
                <li :class="{'active':$store.state.navNum===52}"><a @click="goPage(52,'心理科学')">心理科学</a></li>
                <li :class="{'active':$store.state.navNum===53}"><a @click="goPage(53,'社会科学')">社会科学</a></li>
                <li :class="{'active':$store.state.navNum===54}"><a @click="goPage(54,'管理学')">管理学</a></li>
                <li :class="{'active':$store.state.navNum===55}"><a @click="goPage(55,'计算机')">计算机</a></li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header',
  data () {
    return {
      bannerArr: [
        {url: '/static/t1.jpg'},
        {url: '/static/t2.jpg'},
        {url: '/static/t3.jpg'}
      ],
      loginStatus: false // 是否已登录
    }
  },
  mounted () {
    if (this.Check()) {
      let id = localStorage.getItem('userId') || ''
      let name = localStorage.getItem('userName') || ''
      this.$store.dispatch('userSync', {id: id, name: name})
    }
  },
  filters: {
    sub20 (value) {
      return value.substring(0, 20) + '...'
    }
  },
  methods: {
    goLogin(){
        this.$router.push({path: 'login'})
    },
    goCartA(){
        if(!this.Check()){
            this.$message({
            message: '请登录后再进行信息发布！',
            type: 'error'
            })
            return
        }
        this.$router.push({path: 'cart',query: {type: 2}})
    },
    goCart(value) {
        if (!this.Check()) {
          this.$message({
            message: '请登录后再进行操作！',
            type: 'error'
          })
          return
        }
        this.$router.push({path: 'cart',query: {type: value}})
    },
    // 去列表页
    goPage (val, name) {
      this.$router.push({path: 'page', query: {type: val, name: name}})
    },
    // 供销合作申请
    goHe(){
      this.$router.push({path: 'hezuo'})
    },
    clickOut () {
      localStorage.removeItem('login')
      localStorage.removeItem('loginTime')
      localStorage.removeItem('userId')
      localStorage.removeItem('userName')
      location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/scss" lang="scss" scoped>
.header {
  background: #fff;
  text-align: right;
  .top{overflow: hidden;background: #f8f8f8;border-bottom: #ebebeb solid 1px;
    .info{
      width: 1000px;margin: auto;
      span{display: inline-block;padding: 4px 10px;margin: 0 2px;cursor: pointer;color: #999;font-size: 14px;
        &:hover{color: #e4393c;}
      }
    }
  }
  .w1000{
    width: 1000px;margin: auto;overflow: hidden;
    .logo{
      overflow: hidden;float: left;
      img{
        float: left;height: 70px;margin: 5px 0;
      }
    }
    .cart{width: 130px;height: 34px;border: #eee solid 1px;line-height: 34px;font-size: 14px;color: #e1251b;cursor: pointer;text-align: left;float: right;margin-top: 30px;
      &:hover{border-color: #e4393c;}
      span{width: 34px;height: 34px;position: relative;float: left;background: url('/static/cart.png') center no-repeat;background-size: 60% 60%;margin-left: 10px;margin-right: 6px;
        i{position: absolute;background: #e4393c;display: block;width: 18px;height: 18px;border-radius: 50%;text-align: center;line-height: 18px;color: #fff;font-size: 12px;overflow: hidden;margin-left: 20px;}
      }
    }
  }
  .nav{width: 1000px;margin: auto;height: 50px;line-height: 50px;background: #c7303e;
    ul{
      width: 1000px;margin: auto;overflow: hidden;text-align: left;
      li{width: 16%;display: inline-block;color: #e9b900;text-align: center;font-size: 20px;cursor: pointer;
        a{
          line-height: 50px;text-align: center;font-size: 18px;display: inline-block;position: relative;padding: 0 4px;color: #f6cb00;font-weight: 600;
          &::after{height: 3px;left: 50%;width: 0;position: absolute;content: '';background: #f6cb00;transition:all 0.5s;bottom: 0;border-radius: 2px;}
          &:hover{
            color: #e9b900;
            &::after{height: 3px;width: 100%;left: 0;}
          }
          &.router-link-active{
            color: #e9b900;
            &::after{height: 3px;left: 0;width: 100%;position: absolute;content: '';background: #f6cb00;border-radius: 2px;}
          }
        }
      }
    }
  }
  .banner{
    height: 400px;width: 1000px;margin: auto;
    img{width: 100%;height: 400px;}
  }
}
.logo{font-size: 28px;line-height: 80px;}
</style>
